<arm-layout [summaryTitle]="'JOURNAL SUMMARY'">
  <div header>
    <div class="search-container">
      <arm-search [searchComponent]="alarmsSearchComponent"
                  [searchData]="searchData"
                  [searchTerms]="searchTerms"
                  (onSearch)="onSearch($event)">
      </arm-search>
    </div>

    <div class="action-buttons">
      <arm-action-bar (refreshClick)="refresh()"></arm-action-bar>

      <button mat-raised-button class="more-actions" [matMenuTriggerFor]="menu" color="primary">
        <span>Actions</span>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>

      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="openColumnsConfiguration()">
          <span>Table columns</span>
        </button>
      </mat-menu>
    </div>
  </div>

  <div summary>
    <journal-summary [selection]="selection">
    </journal-summary>
  </div>

  <div main>
    <arm-table [displayedColumns]="displayedColumns" (pageChanged)="pageChanged($event)"
               (onSelection)="onSelection($event)" [data]="data.elements" [length]="data.totalElements"
               [isMultipleSelection]="false"
               [isClientSide]="false"></arm-table>

  </div>
</arm-layout>
